import React from 'react';
import TravelerTripsView from './trips-view';
import useTripMatchSearch from '../../hooks/use-trip-match-search';

interface DefaultSearch {
  [key: string]: string | string[];
  order: string;
  sort: string;
  status: string[];
  traveler: string;
}

const defaultSearch: DefaultSearch = {
  order: 'desc',
  sort: 'createdAt',
  status: [],
  traveler: '',
};

const TravelerTripsContainer = ({ travelerId }: { travelerId: string | undefined }) => {
  defaultSearch.traveler = travelerId || '';

  const {
    tripMatches,
    error,
    hasMore,
    isLoading,
    loadMore,
    totalHits,
  } = useTripMatchSearch(defaultSearch);

  const formattedTMCount = new Intl.NumberFormat('en-US').format(totalHits);

  return (
    <TravelerTripsView
      error={error}
      hasMoreItems={hasMore}
      isLoading={isLoading}
      items={tripMatches}
      loadMore={loadMore}
      totalHits={formattedTMCount}
    />
  );
};

export default TravelerTripsContainer;
